
import { Link, useLocation } from 'react-router-dom';
import { Camera, Trophy, User } from 'lucide-react';

export const BottomNav: React.FC = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/challenge', icon: Camera, label: 'Challenge' },
    { path: '/results', icon: Trophy, label: 'Results' },
    { path: '/profile', icon: User, label: 'Profile' }
  ];
  
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-bauhaus-offwhite shadow-lg border-t border-bauhaus-green/20 safe-area-bottom z-10">
      <div className="flex justify-around py-4">
        {navItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          
          return (
            <Link 
              key={item.path} 
              to={item.path}
              className="flex flex-col items-center px-5"
            >
              <div className={`p-2 ${
                isActive 
                  ? 'bg-bauhaus-green rounded-md shadow-lg'
                  : 'bg-transparent'
              } transition-all duration-300`}>
                <item.icon className={`h-5 w-5 ${isActive ? 'text-bauhaus-offwhite' : 'text-bauhaus-green'}`} />
              </div>
              <span className={`text-xs mt-1 font-bold uppercase tracking-wider ${
                isActive ? 'text-bauhaus-green' : 'text-bauhaus-green/70'
              }`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
